import { render, staticRenderFns } from "./LandingStats.vue?vue&type=template&id=e941c56a"
import script from "./LandingStats.vue?vue&type=script&lang=js"
export * from "./LandingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports